"use client";

import { twMerge } from "tailwind-merge";

import { defaultTableCellStyle } from "./dataset";

type Props = {
  rowIndex: number;
  rowData: React.ReactNode[];
  onRowClick?: (index: number) => void;
  tdStyles: React.CSSProperties[];
};

export const TableRow = ({
  rowIndex,
  rowData,
  onRowClick,
  tdStyles,
}: Props) => (
  <tr
    className={twMerge(
      "border-b border-gray-200",
      onRowClick && "cursor-pointer transition hover:bg-sky-700/5"
    )}
    onClick={(e) => {
      e.preventDefault();
      onRowClick?.(rowIndex);
    }}
  >
    {rowData.map((cell, i) => (
      <td
        key={i}
        className="whitespace-nowrap px-4 py-4 font-medium"
        style={{ ...defaultTableCellStyle, ...tdStyles[i] }}
      >
        {cell}
      </td>
    ))}
  </tr>
);
